<template lang="html">
  <v-form ref="form" lazy-validation autocomplete="off">
    <v-card class="card-size">
      <v-card-title>
        {{ ehEdicao ? $t('title.editar') : $t('title.cadastrar') }} {{ $tc('label.role', 1) }}
      </v-card-title>
      <v-container grid-list-xl fluid>
        <v-row>
          <v-col cols="12">
            <v-text-field
              id="role_nome"
              name="role_nome"
              v-model="role.nome"
              class="Form-text__invalid"
              :label="`${$tc('label.nome', 1)} *`"
              :counter="100"
              maxlength="100"
              auto-grow
              rows="1"
              @keyup="nomeToUpperCase()"
              :rules="[rules.required]">
            </v-text-field>
            <v-textarea
              id="role_titulo"
              name="role_titulo"
              v-model="role.titulo"
              class="Form-text__invalid"
              :label="`${$tc('label.titulo', 1)} *`"
              :counter="150"
              maxlength="150"
              auto-grow
              rows="1"
              :rules="[rules.required]">
            </v-textarea>
            <v-textarea
              id="role_descricao"
              name="role_descricao"
              v-model="role.descricao"
              class="Form-text__invalid"
              :label="`${$tc('label.descricao', 1)} *`"
              :counter="300"
              maxlength="300"
              auto-grow
              rows="1"
              :rules="[rules.required]">
            </v-textarea>
            <v-switch :label="$t('label.exibir_cadastro_perfil')" color="primary" v-model="role.indExibir" class="mt-3"></v-switch>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.native="cancel">{{ $t('label.cancelar') }}</v-btn>
        <v-btn @click.native="openSaveDialog" color="primary">{{ $t('label.salvar') }}</v-btn>
      </v-card-actions>
    </v-card>

    <confirm
      ref="confirmDialog"
      :message="dialog.content"
      :persistent="true"
      @agree="save()">
    </confirm>
  </v-form>
</template>

<script>
import Confirm from '@/shared-components/dialog/Confirm';

export default {
  name: 'RoleForm',
  data() {
    return {
      roleResources: this.$api.role(this.$resource),

      role: {
        id: null,
        nome: null,
        titulo: null,
        descricao: null,
        indExibir: false,
      },
      listaRoles: [],
      buscaListaRoles: null,

      rules: {
        required: (value) => (!!value && !!value.trim()) || this.$t('message.campo_obrigatorio'),
      },
      dialog: {
        content: '',
      },
    };
  },
  watch: {
    buscaListaRoles(val) {
      if (this.timeout) {
        window.clearTimeout(this.timeout);
      }
      this.timeout = window.setTimeout(() => {
        this.buscarRolesAutocomplete(val);
      }, 500);
    },
  },
  components: {
    Confirm,
  },
  methods: {
    cancel() {
      this.limparFormulario();
    },
    editar(role) {
      const codigo = role.id;
      return this.roleResources.buscar({ codigo }, { codigo })
        .then((res) => {
          this.role = res.data;
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    limparFormulario() {
      this.role = {};
      this.$refs.form.reset();
    },
    openSaveDialog() {
      if (!this.$refs.form.validate()) return;
      this.dialog.content = this.$t('message.salvar');
      this.$refs.confirmDialog.open();
    },
    nomeToUpperCase() {
      if (this.role.nome !== null) {
        this.role.nome = this.role.nome.toUpperCase();
      }
    },
    save() {
      let salvarOuAtualizar;
      let inclusao = true;
      this.role.nome = this.role.nome.toUpperCase();

      if (this.role.id != null) {
        inclusao = false;
        salvarOuAtualizar = this.roleResources.atualizar(this.role);
      } else {
        salvarOuAtualizar = this.roleResources.gravar(this.role);
      }

      salvarOuAtualizar
        .then(() => this.limparFormulario())
        .then(() => this.$toast(
          this.$t(
            inclusao
              ? 'message.adicionado_confira_tabela'
              : 'message.atualizado_confira_tabela',
          ),
        ))
        .then(() => {
          this.$emit('FORMULARIO_CADASTRO_ROLE_SALVAR', this.role);
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
  },
  computed: {
    ehEdicao() {
      return this.role.id;
    },
  },
};
</script>
